export default "__VITE_ASSET__DZjp66uK__"